function AnnouncementDetailsController() {
    this.constructor.apply(this, arguments);
}

AnnouncementDetailsController.$inject = ['$scope', 'AnnouncementService', '$stateParams', '$state', 'DeviceService'];
AnnouncementDetailsController.prototype = {
    /**
     *
     * @param $scope {angular.IScope}
     * @param AnnouncementService {AnnouncementService}
     * @param $stateParams {angular.ui.IStateParams}
     * @param $state {angular.ui.IStateService}
     * @param DeviceService {DeviceService}

     */
    constructor($scope, AnnouncementService, $stateParams, $state, DeviceService) {
        this.$scope = $scope;
        this.announcementService = AnnouncementService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.deviceService = DeviceService;

        // Go to to prev because don't have details in memory to display
        if(!this.announcementService.announcementDetails){
            this.goBack();
        }

        /** @type {IAnnouncement} */
        this.item = this.announcementService.announcementDetails;

        this.deviceService.onGoBackButton(this.$scope, this.goBack.bind(this));

        // Remove data after destroy
        this.$scope.$on('$destroy',()=>{
            delete this.announcementService.announcementDetails;
        })
    },

    goBack() {
        this.$state.go(this.$stateParams.prevState || 'internal.announcements');
    }
}
angular.module('internal.announcements').controller('AnnouncementDetailsController', AnnouncementDetailsController);